module.exports = __webpack_public_path__ + "img/Telluride-Red.c6e9b092.png";